export default __webpack_public_path__ + "static/media/cloud4.9139d9c3.svg";